<template>
  <g class="map-mask">
    <image
      :x="x"
      :y="y"
      :width="width"
      :height="height"
      :xlink:href="require('@/assets/images/honmachi_mask.png')"
    />
  </g>
</template>

<script>
export default {
  computed: {
    currentBuilding: ({ $store, currentBuildingId }) => $store.getters['area/buildingFind'](currentBuildingId),
    currentBuildingId: ({ $store }) => $store.state.current.buildingId,
    mapMargin: () => ({
      top: 0.4,
      right: 0.4,
      bottom: 0.4,
      left: 0.4,
    }),
    height: (vm) => vm.currentBuilding.depth + vm.mapMargin.top + vm.mapMargin.bottom,
    width: (vm) => vm.currentBuilding.width + vm.mapMargin.left + vm.mapMargin.right,
    x: (vm) => -vm.mapMargin.left,
    y: (vm) => -(vm.currentBuilding.depth + vm.mapMargin.top),
  },
};
</script>

<style scoped lang="scss">
.map-mask > image {
  transition: opacity .5s;
}
</style>



// WEBPACK FOOTER //
// map_mask_image.vue?f82e5020